export default __webpack_public_path__ + "static/media/pointer-down.b030d3ad.png";